import classNames from 'classnames';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { createSelector } from 'reselect';
import KeepAlive, { useActivate, useUnactivate } from 'react-activation';

import { logging, logPostInfo } from '../../actions/log';
import {
  getLocalSoft,
  removeUninstall,
  setResidualNotifyStatus,
  setRarelyNotifyStatus,
} from '../../actions/native';
import {
  addUninstall,
  cancelUninstall,
  getMixBatchDetails,
  getUninstallCategory,
  setResidualList,
  setTempResidualList,
} from '../../actions/uninstall';
import Loading from '../../components/Loading/Loading';
import { CONTEXT } from '../../config';
import { PCStoreJsBridge } from '../../nativeapi';
import { getParamString2, getQueryString2, logNative, sumAll } from '../../utils/utils';
import Category from './Category';
import ResidualSoftList from './ResidualSoftList';
import styles from './Uninstall.module.less';
import UninstLineCard from './UninstLineCard';
import { Link } from 'react-router-dom';
import Dialog from '../../components/Dialog/Dialog';
import Config from './Uninstall.config';
import NotOftenUsedSoft from './NotOftenUsedSoft';
import qs from 'query-string';
import Toast from '../../components/Toast/Toast';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

const selectNative = createSelector(
  state => state.native,
  native => native,
);
const selectUninstall = createSelector(
  state => state.uninstall,
  uninstall => uninstall,
);

function Uninstall() {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const logInfoData = useSelector(selectLogInfo);
  const {
    installedSoft,
    installedSoftInit,
    commandLine,
    uninstallSoft: uninstallSoftList,
    residualNotifyStatus, // 残留通知开关
    rarelyNotifyStatus,
  } = useSelector(selectNative);
  const {
    categoryList,
    residualList,
    tempResidualList,
    softsDetail: mixBatchDetails,
  } = useSelector(selectUninstall);
  const {
    handleOrderBy,
    handleInstallSoftByType,
    handleDisableUninstallSoft,
    handlePCSoftByCategory,
    handleANDSoftByCategory,
    handleNotOftenUsedSoft,
  } = Config;

  const [andInstalledShow, setAndInstalledShow] = useState([]);
  const [andInstalled, setAndInstalled] = useState([]);
  const [pcInstalled, setPcInstalled] = useState([]);
  const [pcInstalledShow, setPcInstalledShow] = useState([]);
  const [categorys, setCategorys] = useState([]);
  const [pcCategorySofts, setPcCategorySofts] = useState({});
  const [andCategorySofts, setAndCategorySofts] = useState({});

  const search = qs.parse(location.search) || {};
  const [activeCategory, setActiveCategory] = useState(search.tag || 'all_zw');
  const [loading, setLoading] = useState(true);
  const tempResidualIconRef = useRef(null);
  const tempResidualListRef = useRef(null);
  const activeCategoryRef = useRef(null);
  const [forceUninstall, setForceUninstall] = useState(null);

  const [sortMenu, setSortMenu] = useState('time'); // 排序方式
  const [notOftenUsedSofts, setNotOftenUsedSofts] = useState([]);

  const [tempResidualIcon, setTempResidualIcon] = useState(null);

  const [initTime, setInitTime] = useState(+new Date());

  // 浏览时长打桩
  const leaveTimeLog = useCallback(() => {
    const leaveTime = +new Date();
    dispatch(
      logging({
        category: 'I',
        action: 'View_Time',
        label: '',
        param2: {
          source: `Mysofts`,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          initTime,
          leaveTime,
          time: leaveTime - initTime,
        },
      }),
    );
  }, [initTime]);

  const pvLog = () => {
    //
    dispatch(
      logging({
        category: 'P',
        action: 'Mysofts',
        label: '',
        param2: {
          source: 'Mysofts',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );
    dispatch(
      logPostInfo({
        source: 'Mysofts',
        source_p: logInfoData.source_p,
        source_pp: logInfoData.source_pp,
      }),
    );
  };

  useActivate(() => {
    setInitTime(+new Date());
    pvLog();
  });
  useUnactivate(() => {
    leaveTimeLog();
    dispatch(
      logPostInfo({
        source_p: `Mysofts||${activeCategory}`,
      }),
    );
  });

  // 初始化获取残留和不常用软件开关状态
  const getSwitchStatus = param => {
    PCStoreJsBridge.getAppStoreSwitch({
      ...param,
    }).then(({ succ, enable }) => {
      if (succ) {
        if (param.type === 3) {
          dispatch(setResidualNotifyStatus(!!enable));
        }
        if (param.type === 4) {
          dispatch(setRarelyNotifyStatus(!!enable));
        }
      }
    });
  };
  useEffect(() => {
    getSwitchStatus({ type: 3 });
    getSwitchStatus({ type: 4 });
  }, []);

  // 判断是不是右键调入该页面，需要定位到某一页面
  useEffect(() => {
    if (!commandLine || pcInstalledShow.length < 1) {
      return;
    }
    const rollPosition = () => {
      const lnkTargetUrl = getQueryString2('lnkTarget', location.search) || '';
      if (!lnkTargetUrl) {
        return;
      }
      const lnkTarget = getParamString2('lnkTarget', commandLine) || '';
      if (lnkTarget && pcInstalledShow && pcInstalledShow.length > 0) {
        if (lnkTarget.indexOf('WeGameLauncher') > -1) {
          dispatch(
            logging({
              category: 'R',
              action: 'Uninstall_WeGameLauncher',
              label: '',
              param2: {
                source: 'Mysofts',
                source_p: logInfoData.source_p,
                source_pp: logInfoData.source_pp,
                lnkTarget: encodeURIComponent(lnkTarget),
                text: '2021-7-9 优化代码，路径中包含 WeGameLauncher',
              },
            }),
          );
          return false;
        }

        PCStoreJsBridge.getSoftwareAndBits({ lnkTarget }).then(res => {
          if (res.succ) {
            const el = document.querySelector(`[data-softtag='${res.softGUID}-${res.isx64}']`);
            const result = pcInstalledShow.find(
              item =>
                item.softGUID === res.softGUID &&
                item.isx64 === res.isx64 &&
                item.androidType !== '1',
            );
            const found = uninstallSoftList.find(
              v =>
                (result.androidType !== '1' && v.softGUID === result.softGUID) ||
                (result.androidType === '1' && v.packageName === result.packageName),
            );
            const forceRes = (result && result.title) || found ? null : result;
            setForceUninstall(forceRes);
            if (forceRes) {
              dispatch(
                logging({
                  category: 'P',
                  action: 'Uninstall_Protect',
                  label: '',
                  param2: {
                    source: 'Mysofts',
                    source_p: logInfoData.source_p,
                    source_pp: logInfoData.source_pp,
                    softid: result.softID || result.SoftID || result.softid,
                    type: 'right_uninstall',
                  },
                }),
              );
            }
            if (el) {
              el.scrollIntoView({ block: 'center' });
              history.replace(`${CONTEXT}/uninstall`);
            }
          }
        });
      }
    };
    const timer = setTimeout(() => {
      rollPosition();
      clearTimeout(timer);
    }, 400);
    // eslint-disable-next-line consistent-return
    return () => {
      clearTimeout(timer);
    };
  }, [mixBatchDetails, installedSoft, commandLine, pcCategorySofts, uninstallSoftList]);

  useEffect(() => {
    tempResidualIconRef.current = tempResidualIcon;
    tempResidualListRef.current = tempResidualList;
    activeCategoryRef.current = activeCategory;
  });

  // 获取不常用软件列表
  useEffect(() => {
    PCStoreJsBridge.getNotOftenUsedSofts()
      .then(softList => {
        setNotOftenUsedSofts(handleNotOftenUsedSoft(softList || []));
      })
      .catch(err => {
        logNative(err);
      });
  }, []);
  // 获取残留文件列表
  useEffect(() => {
    PCStoreJsBridge.getSoftwareListResidual().then(res => {
      if (res) {
        dispatch(
          setResidualList(
            res.residualList
              .map(soft => ({
                ...soft,
                SoftID: soft.softid,
                source: 'residualList',
                status: 'init',
                percent: 0,
                hasResidual: true,
              }))
              .filter(item => item.totalSize <= 200 * 1024 * 1024),
          ),
        );
      }
    });
  }, []);

  // 订阅软件卸载扫描残留消息、卸载消息、安卓卸载消息
  useEffect(() => {
    PCStoreJsBridge.subscribeMessage(msg => {
      if (msg.getMsgcategory() === 'APKS_NT_UNINSTALL_DONE') {
        const ret = PCStoreJsBridge.arrayToUTF8String(msg.getMessageproto());
        try {
          const retJson = JSON.parse(ret);
          logNative(`通知 APKS_NT_UNINSTALL_DONE 卸载状态${ret}`, retJson, true, true);
          // 卸载成功
          if (retJson.succ === 'true') {
            // 不再获取安装列表，成功直接从当前列表移除
            dispatch(
              removeUninstall({
                ...retJson,
                androidType: '1',
                packageName: retJson.pkg,
              }),
            );
          }
          // 卸载失败或取消卸载，删除卸载任务
          dispatch(
            cancelUninstall({
              ...retJson,
              androidType: '1',
              packageName: retJson.pkg,
            }),
          );
          // setUninstallSoft(null);
        } catch (error) {
          logNative(`通知 APKS_NT_UNINSTALL_DONE JSON 解析错误${error}`, error);
        }
      }
    });
  }, [dispatch]);

  /**
   *
   * @param {*} pcInstalleds  已安装的pc软件
   * @param {*} andInstalleds 已安装的安卓软件
   * @returns  根据软件的softid和包名获取各个软件的分类
   */
  const handleMixBatchers = (pcInstalleds = [], andInstalleds = []) => {
    if (pcInstalleds.length === 0 && andInstalleds.length === 0) {
      return;
    }
    dispatch(
      getMixBatchDetails({
        params: {
          softIds: pcInstalleds.map(item => item.SoftID).filter(item => item),
          pns: andInstalleds.map(item => item.packageName).filter(item => item),
        },
      }),
    );
  };

  // 获取本地安装的软件
  useEffect(() => {
    dispatch(getLocalSoft());
  }, []);
  /**
   * 页面初始化时，利用从把本地获取的已安装软件列表，拆分成pc软件与安卓软件
   */
  useEffect(() => {
    const { andInstalled: andList, pcInstalled: pcList } = handleInstallSoftByType(installedSoft);
    // 这里这样是一次 为了解决获取类型地址失败  后面不走的情况
    setAndInstalled(andList);
    setPcInstalled(pcList);
    handleMixBatchers(pcList, andList);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [installedSoft]);
  /**
   * 根据服务端获取的软件及软件的详情信息 映射softid/packagename ---soft的信息
   */
  useEffect(() => {
    if (mixBatchDetails && mixBatchDetails.length > 0) {
      const obj = {};
      mixBatchDetails.forEach(item => {
        obj[item.softID] = item;
      });
      setTempResidualIcon({ ...obj });
    }
  }, [mixBatchDetails]);

  /**
   * 统计不可卸载的应用
   */
  useEffect(() => {
    const { allSoft, cantOpenSoft } = handleDisableUninstallSoft(
      installedSoftInit,
      mixBatchDetails || [],
    );
    if (cantOpenSoft.length > 0) {
      dispatch(
        logging({
          category: 'I',
          action: 'Mysofts_Cant_Open',
          label: '',
          param2: {
            source: 'Mysofts',
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            cantOpenSoft,
            allSoft,
          },
        }),
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [installedSoftInit, mixBatchDetails]);

  useEffect(() => {
    // 卸载页-卸载页页面呈现-打桩 PV
    dispatch(
      logging({
        category: 'P',
        action: 'Mysofts',
        label: '',
        param2: {
          source: 'Mysofts',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );
    dispatch(
      logPostInfo({
        source: 'Mysofts',
        source_p: logInfoData.source_p,
        source_pp: logInfoData.source_pp,
      }),
    );
  }, [dispatch]);

  // 点击查看更多软件
  const handleShowMore = useCallback(flag => {
    if (flag) {
      setAndInstalledShow(andCategorySofts[activeCategory] || []);
    } else {
      setAndInstalledShow(
        (andCategorySofts[activeCategory] && andCategorySofts[activeCategory].slice(0, 3)) || [],
      );
    }
  });

  const handleSort = useCallback(flag => {
    setSortMenu(flag);
    // 卸载页-切换排序方式
    dispatch(
      logging({
        category: 'C',
        action: 'Mysofts_Sort',
        label: '',
        param2: {
          type: flag,
          source: 'Mysofts',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );
  });

  // v6.1 20200907 zw
  // 点击标签分类
  const handleActiveCategory = useCallback(
    (active = 'all_zw', vpcCategorySofts, vandCategorySofts) => {
      if (!installedSoft || installedSoft.length === 0) {
        return;
      }
      const tempPCCategorySofts = vpcCategorySofts || pcCategorySofts || {};
      const tempANDCategorySofts = vandCategorySofts || andCategorySofts || {};
      setActiveCategory(active);
      if (active === 'residual') {
        setPcInstalledShow([]);
        setAndInstalledShow([]);
      }
      setPcInstalledShow(tempPCCategorySofts[active] || []);
      setAndInstalledShow(
        (tempANDCategorySofts[active] && tempANDCategorySofts[active].slice(0, 3)) || [],
      );
    },
  );
  useEffect(() => {
    dispatch(setTempResidualList([]));
    dispatch(setResidualList([]));
  }, []);

  // 处理请求获取标签（tag）大类显示的名称
  useEffect(() => {
    dispatch(getUninstallCategory());
  }, []);

  // 根据软件的分类和本地已安装软件 残留软件整理各个tab下面显示的数据
  useEffect(() => {
    // if (!categoryList || !mixBatchDetails) {
    //   return;
    // }
    // 处理pc软件
    const recordObj = handlePCSoftByCategory(
      mixBatchDetails || [],
      pcInstalled,
      tempResidualListRef.current,
      notOftenUsedSofts,
      tempResidualIconRef.current,
    );
    // 处理安卓软件
    const andRecordObj = handleANDSoftByCategory(
      mixBatchDetails || [],
      andInstalled,
      tempResidualListRef.current,
    );

    // 剔除无效的category分类标签
    if (categoryList && categoryList.length > 0) {
      setCategorys(
        categoryList.filter(
          item =>
            (recordObj[item.id] && recordObj[item.id].length > 0) ||
            (andRecordObj[item.id] && andRecordObj[item.id].length > 0),
        ),
      );
    }

    // 排序pc各分类信息下面的软件
    Object.keys(recordObj).forEach(key => {
      recordObj[key] = handleOrderBy(recordObj[key], sortMenu);
    });
    // 保存完整的以分类tagid为key的数据
    setPcCategorySofts(recordObj);

    // 排序安卓各分类信息下面的软件
    Object.keys(andRecordObj).forEach(key => {
      andRecordObj[key] = handleOrderBy(andRecordObj[key], sortMenu);
    });
    // 保存完整的以分类tagid为key的数据
    setAndCategorySofts(andRecordObj);

    // 刷新数据 重新计算选中的tag
    let active = activeCategoryRef.current;

    if (active === 'residual') {
      return;
    }
    if (
      (!recordObj[activeCategory] || recordObj[activeCategory].length === 0) &&
      (!andRecordObj[activeCategory] || andRecordObj[activeCategory].length === 0) &&
      recordObj.all_zw &&
      recordObj.all_zw.length !== 0
    ) {
      active = 'all_zw';
    }
    setActiveCategory(active);
    handleActiveCategory(active, recordObj, andRecordObj);
  }, [categoryList, mixBatchDetails, pcInstalled, andInstalled, sortMenu, notOftenUsedSofts]);

  const handleForceUninstall = useCallback(() => {
    // 确认打桩
    dispatch(
      logging({
        category: 'C',
        action: 'Uninstall_Protect_Continue',
        label: '',
        param2: {
          source: 'Mysofts',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          type: 'right_uninstall',
          softid: forceUninstall.softID || forceUninstall.SoftID || forceUninstall.softid,
          softname: forceUninstall.softName,
        },
      }),
    );
    dispatch(addUninstall(forceUninstall));
    PCStoreJsBridge.uninstallSoft(forceUninstall);
    setForceUninstall(null);
  }, [forceUninstall]);

  const handleClose = useCallback(
    type => {
      // 取消或者关闭打桩
      dispatch(
        logging({
          category: 'C',
          action: type === 'close' ? 'Uninstall_Protect_Close' : 'Uninstall_Protect_Cancel',
          label: '',
          param2: {
            source: 'Mysofts',
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            type: 'right_uninstall',
            softid: forceUninstall.softID || forceUninstall.SoftID || forceUninstall.softid,
            softname: forceUninstall.softName,
          },
        }),
      );
      setForceUninstall(null);
    },
    [forceUninstall],
  );
  const handleClickCollect = () => {
    // 点击我的收藏打桩
    dispatch(
      logging({
        category: 'C',
        action: 'Mysofts_Collect',
        label: '',
        param2: {
          source: 'Mysofts',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );
  };
  const handlePCTagSoftCount = tagType => {
    switch (tagType) {
      case 'all_zw':
        return (residualList || []).length + pcInstalledShow.length;
      case 'residual':
        return (residualList || []).length + (tempResidualList || []).length;
      case 'not_often_used_softs':
        return (pcInstalledShow || []).length;
      default:
        return (pcInstalledShow || []).length;
    }
  };
  /**
   * 获取本地不常用软件
   */
  useEffect(() => {
    PCStoreJsBridge.getNotOftenUsedSofts()
      .then(() => {})
      .catch(err => {
        logNative(`获取本地不常用软件错误${err}`);
      });
  }, []);
  /**
   * loading状态判断
   */
  useEffect(() => {
    if (
      (mixBatchDetails && mixBatchDetails.length !== 0) ||
      (categoryList && categoryList.length !== 0)
    ) {
      setLoading(false);
    }
  }, [mixBatchDetails, categoryList]);

  const handleSetting = (type, enable) => () => {
    PCStoreJsBridge.setAppStoreSwitch({
      type,
      enable,
      source: 4,
    }).then(
      res => {
        if (res.code !== 0 || !res.succ) {
          Toast.error({
            content: '设置失败！',
          });
        } else {
          Toast.success({ content: '设置成功！' });
        }
        getSwitchStatus({ type });
      },
      () => {
        Toast.error({
          content: '设置失败！',
        });
      },
    );
    dispatch(
      logging({
        category: 'C',
        action: 'Mysofts_App_Setting',
        label: '',
        param2: {
          source: 'Mysofts',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          type,
        },
      }),
    );
  };

  if (loading) {
    return (
      <div
        style={{ height: '600px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
      >
        <Loading />
      </div>
    );
  }
  return (
    <div className={styles.page}>
      <div className={styles.page_container}>
        <div className={styles.category_box}>
          <div className="mysoftware_header">
            <div className="header_text">
              已安装
              <span className="totalNumberText">
                {andInstalled.length + pcInstalled.length + residualList.length}
              </span>
              款软件，共占用硬盘
              <span className="totalMemoryText"> {sumAll(installedSoft)}</span>
            </div>
            <div>
              <Link
                to={{
                  pathname: `${CONTEXT}/collection`,
                }}
                onClick={handleClickCollect}
              >
                <div className={styles.header_collect}>
                  <i className={classNames('iconfont icon-collect', styles.collect_icon)}></i>
                  我的收藏
                </div>
              </Link>
              <div className={styles.header_menu}>
                <div className={classNames(styles.menu_text, styles.menu_active, styles.menu_show)}>
                  {sortMenu === 'time' ? '安装时间' : '软件大小'}
                  <i
                    className={classNames(
                      'iconfont',
                      styles.menu_text,
                      styles.menu_icon,
                      styles.menu_active,
                    )}
                  />
                </div>
                <div className={classNames(styles.menu_modal)}>
                  <div
                    className={classNames(styles.menu_text_small, {
                      [styles.menu_active]: sortMenu === 'time',
                    })}
                    onClick={() => {
                      handleSort('time');
                    }}
                  >
                    安装时间
                  </div>
                  <div
                    className={classNames(styles.menu_text_small, {
                      [styles.menu_active]: sortMenu === 'size',
                    })}
                    onClick={() => {
                      handleSort('size');
                    }}
                  >
                    软件大小
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className={styles.category}>
            <Category
              getActive={handleActiveCategory}
              categoryList={categorys}
              showResidual={tempResidualList.length + residualList.length > 0}
              showNotOftenUsedSofts={notOftenUsedSofts && notOftenUsedSofts.length}
              active={activeCategory}
            />
          </div>
        </div>
        {andCategorySofts[activeCategory] && andCategorySofts[activeCategory].length > 0 && (
          <React.Fragment>
            <div className="mysoftware_title" style={{ marginTop: '25px' }}>
              <i className="icon iconfont icon-Android" />
              <span>
                安卓软件
                {`（${(andCategorySofts[activeCategory] &&
                  andCategorySofts[activeCategory].length) ||
                  ''}）`}
              </span>
            </div>
            <div className="mysoftware_softlist" style={{ marginTop: '14px' }}>
              {andInstalledShow.map((soft, i) => (
                <UninstLineCard
                  soft={soft}
                  logInfo={{}}
                  key={`${i}_${activeCategory}_${soft.packageName}`}
                />
              ))}
              {andCategorySofts[activeCategory] && andCategorySofts[activeCategory].length > 3 && (
                <React.Fragment>
                  {andCategorySofts[activeCategory] &&
                    andCategorySofts[activeCategory].length > andInstalledShow.length && (
                      <div
                        className="softlist_show_more"
                        onClick={() => {
                          handleShowMore(true);
                        }}
                      >
                        <div className="softlist_show_all">查看全部</div>
                        <span className="iconfont icon-arrow_down_small arrow_icon_down" />
                      </div>
                    )}
                  {andCategorySofts[activeCategory] &&
                    andCategorySofts[activeCategory].length === andInstalledShow.length && (
                      <div
                        className="softlist_show_more"
                        onClick={() => {
                          handleShowMore(false);
                        }}
                      >
                        <div className="softlist_show_less">收起</div>
                        <span className=" iconfont icon-arrow_up_small arrow_icon_up" />
                      </div>
                    )}
                </React.Fragment>
              )}
            </div>
          </React.Fragment>
        )}
        {handlePCTagSoftCount(activeCategory) > 0 && (
          <React.Fragment>
            <div className="mysoftware_title_pc" style={{ marginTop: '25px' }}>
              <i className="icon iconfont icon-PC" />
              <span>
                电脑软件
                {`（${handlePCTagSoftCount(activeCategory)}）`}
              </span>
            </div>
            <div className="mysoftware_softlist softlist_pc" style={{ marginTop: '14px' }}>
              {activeCategory !== 'not_often_used_softs' &&
                pcInstalledShow.map((soft, i) => (
                  <UninstLineCard
                    soft={soft}
                    logInfo={{}}
                    key={`${i}_${activeCategory}_${soft.SoftID}`}
                    tempResidualList={tempResidualList}
                    softInfo={tempResidualIcon}
                  />
                ))}
              {(activeCategory === 'all_zw' || activeCategory === 'residual') &&
                installedSoft &&
                installedSoft.length > 0 &&
                Object.keys(pcCategorySofts).length > 0 && (
                  <ResidualSoftList
                    activeCategory={activeCategory}
                    mixBatchDetails={mixBatchDetails || []}
                  />
                )}
              {activeCategory === 'not_often_used_softs' &&
                pcInstalledShow.map((soft, i) => (
                  <NotOftenUsedSoft
                    soft={soft}
                    logInfo={{}}
                    key={`${i}_${activeCategory}_${soft.SoftID}`}
                    tempResidualList={tempResidualList}
                    softInfo={tempResidualIcon}
                    pcInstalled={pcInstalled}
                  />
                ))}
            </div>
          </React.Fragment>
        )}

        {activeCategory === 'residual' && !residualNotifyStatus && (
          <div onClick={handleSetting(3, true)} className={styles.notify}>
            您尚未开启卸载残留提醒，建议您
            <span className={styles.notify_btn}>&nbsp;立即开启&nbsp; &gt;</span>
          </div>
        )}
        {activeCategory === 'not_often_used_softs' && !rarelyNotifyStatus && (
          <div onClick={handleSetting(4, true)} className={styles.notify}>
            您尚未开启卸载残留提醒，建议您
            <span className={styles.notify_btn}>&nbsp;立即开启&nbsp; &gt;</span>
          </div>
        )}

        {!!forceUninstall && (
          <Dialog
            title="温馨提示"
            maskStyle={styles.mask}
            containerStyle={styles.containerStyle}
            handleClose={() => {
              handleClose('close');
            }}
          >
            <div className={styles.modal_content}>
              您确定要卸载
              <div className={styles.soft_name}>{forceUninstall && forceUninstall.displayName}</div>
              吗？
            </div>
            <div className={styles.modal_button}>
              <div
                className={classNames(styles.button, styles.uninstall)}
                onClick={handleForceUninstall}
              >
                立即卸载
              </div>
              <div className={classNames(styles.button, styles.install)} onClick={handleClose}>
                取消卸载
              </div>
            </div>
          </Dialog>
        )}
      </div>
    </div>
  );
}

export default () => (
  <KeepAlive name="uninstall">
    <Uninstall></Uninstall>
  </KeepAlive>
);
